/**
 * render-aggregate-viewing-time-by-bvod-player-csv
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2018 Mediatel Limited.
 */

"use strict";

import numberFormat from "../common/number-format";

export default function renderWeeklyReportCSV(data, options) {
    if(! data.length) {
        return 'No data for this week yet'
    }
    let showTv = false;
    const decimals = (parseInt(options.dataType) === 0) ? 0 : 2;
    const rows = data.filter(
        s => options.showTotal ? true : (s.player_name.match(new RegExp("^(?!All BVOD services$).*", "i")))
    ).filter(
        s => options.filter ? (s.player_name.match(new RegExp("^" + options.filter + "|All BVOD service", "i"))) : true
    ).map((viewing) => {
        let row = `"${viewing.player_name}",` +
            `"${viewing.stream_name}",` +
            `"${(viewing.all_devices) ? numberFormat(viewing.all_devices, decimals) : "-"}",` +
            `"${(viewing.pc) ? numberFormat(viewing.pc, decimals) : "-"}",` +
            `"${(viewing.tablet) ? numberFormat(viewing.tablet, decimals) : "-"}",` +
            `"${(viewing.smartphone) ? numberFormat(viewing.smartphone, decimals) : "-"}",`;
        if (viewing.hasOwnProperty('tv_device')) {
            showTv = true;
            row += `"${(viewing.tv_device) ? numberFormat(viewing.tv_device, decimals) : "-"}",`;
        }
        row += `"${(viewing.other) ? numberFormat(viewing.other, decimals) : "-"}"`;
        return row;
    }).join("\n");

    let output = `"Player name",` +
        `"Stream name",` +
        `"All devices",` +
        `"PC/loptop",` +
        `"Tablet",` +
        `"Smartphone",`;
    if (showTv) {
        output += `"TV device",`;
    }
    output += `"Other"` +
        `\r\n${rows}`;
    return output;
};